export default "__VITE_ASSET__CtKX$Oat__"